import { QuestionTypeV2Enum } from '@doltech/utils/lib/constants';
import {
  OldBlankDoTestPlugin,
  OldBlankDoTestPluginProps,
  OldBlankPlugin,
} from '../BlankEditor/Creator/OldBlankPlugin';
import { OldBlankResultPlugin } from '../BlankEditor/Result/OldBlankResultPlugin';
import { withBlank } from '../BlankEditor/withBlank';
import { EditableVoidPlugin } from '../DolEditor/elements/editable-blank-voids/EditableVoidBlankPlugin';
import { useSideToolbarPlugins } from '../DolEditor/toolbars/sidebar/defaults';
import { DoTestImageWithBlankPlugin } from '../ImageBlankEditor/DoTestImageWithBlankPlugin';
import { ResultImageWithBlankPlugin } from '../ImageBlankEditor/ResultImageWithBlankPlugin';

export const useBlankEditorCreator = ({ blanks, onRemoveBlank }) => {
  return useSideToolbarPlugins({
    extraPlugins: [OldBlankPlugin({ blanks, onRemoveBlank })],
    extraEditorChains: [withBlank],
  });
};

export const useBlankEditorResult = ({
  blanks,
  currentSelectedIndex,
  showQuestionNo,
  testMode,
  questionType = null,
  noCheckIndex = false,
}) => {
  return useSideToolbarPlugins({
    extraPlugins: [
      OldBlankResultPlugin({
        blanks,
        currentSelectedIndex,
        showQuestionNo,
        testMode,
        noCheckIndex,
      }),
      questionType === QuestionTypeV2Enum.NOTE_FORM_COMPLETION_V2 &&
        ResultImageWithBlankPlugin({
          blanks,
          currentSelectedIndex,
          showQuestionNo,
          testMode,
        }),
    ],
    extraEditorChains: [withBlank],
  });
};

export const useBlankEditorDoTest = (blankOptions: OldBlankDoTestPluginProps) => {
  return useSideToolbarPlugins({
    extraPlugins: [
      OldBlankDoTestPlugin(blankOptions),
      blankOptions?.questionType === QuestionTypeV2Enum.NOTE_FORM_COMPLETION_V2 &&
        DoTestImageWithBlankPlugin({
          no: blankOptions?.no,
          blankValues: blankOptions?.blankValues,
          blanks: blankOptions.blanks,
          onBlankChange: blankOptions?.onBlankChange,
        }),
    ],
  });
};

export const useBlankEditorDiagramLabel = ({
  blanks,
  questionNo,
  readOnly,
  mode,
  userAnswers,
  selectBlankIndex,
  onUserAnswerChange,
  onClickBlank,
  withDot = false,
  noArrow = false,
  showBlankBackground = false,
  withQuestionNoOutsideBlankBlock = false,
}) => {
  const { plugins, editorChains } = useSideToolbarPlugins({
    extraPlugins: [
      EditableVoidPlugin({
        blanks,
        questionNo,
        readOnly,
        mode,
        userAnswers,
        selectBlankIndex,
        onUserAnswerChange,
        onClickBlank,
        noArrow,
        withDot,
        showBlankBackground,
        withQuestionNoOutsideBlankBlock,
      }),
    ],
  });

  return {
    plugins,
    editorChains,
  };
};
